<template>
  <div class="row justify-content-center pt-3">
    <div class="col-12 col-md-7 text-center">
      <div class="alert alert-danger rounded-pill p-2 mx-3"><span v-if="errorNumber && errorNumber > 0" class="badge text-bg-danger mx-2">{{errorNumber}}</span>{{ alertMessage }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'erroralert',
  props: {
    alertMessage: "",
    errorNumber: null,
  }
}
</script>